import './App.css';
import Header from './Layout/Header';
import { BrowserRouter } from 'react-router-dom'
import AppRoute from './Variables/AppRoute';
import Footer from './Layout/Footer';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { MetadataProvider } from './Contexts/MetadataContext';
import Meta from './Components/Meta';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  // const [menu, setMenu] = useState([]);
  // const getMenu = () => {
  //     fetch(variables.API_URL + "Menu/GetMenues", {
  //         method: "GET",
  //         headers: {
  //             Accept: "application/json",
  //             "Content-Type": "application/json",
  //         },
  //     })
  //         .then((Response) => Response.json())
  //         .then((Result) => {
  //             setMenu(Result);
  //         });
  // }
  return (
    <div >
      <HelmetProvider>
        <MetadataProvider>
          <BrowserRouter>
            <Header />
            <Meta />
            <AppRoute />
            <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <Footer />
          </BrowserRouter>
        </MetadataProvider>
      </HelmetProvider>

    </div>
  );
}

export default App;
